import React, { useEffect, useRef, useState } from "react";
import { actionCreators } from "./redux/sagas/userMenu/userMenu";
import { Notification } from "./smartComponents/Notification";
import { Links } from "./smartComponents/Links";
import { ThemeToggle } from "./smartComponents/ThemeToggle";
import { TOSModal } from "./smartComponents/TOSModal";
import { AvatarUpload } from "./smartComponents/AvatarUpload";
import fallbackImg from "../../../../../public/avatars/original/missing.png";
import { useSelector, useDispatch } from "react-redux";
import { ArrowIcon } from "../../../../assets/images/svg";
import ReactTooltip from "react-tooltip";

export function UserMenuModule({ userParams, currentUser }) {
  const dispatch = useDispatch();
  const avatarURL = useSelector((state) => state.userMenu.currentUser.avatarURL);

  const emailRef = useRef();

  const [showTooltip, setShowTooltip] = useState(false);

  const [state, setState] = useState({
    showMenu: false,
    showImageEdit: false,
    showCamera: false,
    showUpload: false
  });

  const closeAll = () => {
    setState({
      showMenu: false,
      showImageEdit: false,
      showCamera: false,
      showUpload: false
    });
  };

  const handleState = (key, val) => {
    setState((prev) => ({ ...prev, [key]: val }));
  };

  const toggleMenu = () => {
    let wrapper = document.querySelector(".user");
    let overlay = document.querySelector("#globalOverlay");

    if (wrapper && overlay) {
      wrapper.classList.toggle("active");
      overlay.classList.toggle("active");
      handleState("showMenu", !state.showMenu);
    }
  };

  const onImageError = (e) => {
    e.target.src = fallbackImg;
  };

  useEffect(() => {
    let wrapper = document.querySelector(".user");
    let overlay = document.querySelector("#globalOverlay");

    overlay.addEventListener("click", () => {
      closeAll();

      overlay.classList.remove("active");
      wrapper.classList.remove("active");
    });

    dispatch(actionCreators.fetchCurrentUser(currentUser));
  }, []);

  useEffect(() => {
    let node = emailRef.current;

    if (node && state.showMenu) {
      setShowTooltip(node.scrollWidth > node.clientWidth);
    }
  }, [state.showMenu]);

  return (
    <div className="user">
      <TOSModal />

      <Notification />

      <div className="username" onClick={() => toggleMenu()}>
        <img className="user-avatar" src={avatarURL} onError={onImageError} />
      </div>

      <div className="user-menu">
        <div
          className={`user-menu__content 
            ${state.showMenu && !state.showImageEdit ? "is-active" : ""}`}
        >
          <div className="user-menu__info">
            <div className="avatar">
              <img
                src={avatarURL}
                onClick={() => handleState("showImageEdit", true)}
                alt="avatar"
                onError={onImageError}
              />
            </div>

            <div>
              <div className="full-name">{userParams.userFullName}</div>
              <div className="email" data-tip="" ref={emailRef} data-for="user-menu-email">
                {userParams.userEmail}
              </div>
              {showTooltip && (
                <ReactTooltip id="user-menu-email">{userParams.userEmail}</ReactTooltip>
              )}
            </div>
          </div>

          <ul className="user-menu__list">
            <ThemeToggle />
            <Links userParams={userParams} />
          </ul>
        </div>

        <div className={`avatar-upload ${state.showImageEdit ? "is-active" : ""}`}>
          {!state.showCamera && !state.showUpload && (
            <>
              <div className="avatar-upload__title">
                <div className="back" onClick={() => handleState("showImageEdit", false)}>
                  <ArrowIcon />
                </div>
                <div className="title">Edit Profile Image</div>
              </div>

              <div className="avatar-upload__preview">
                <img src={avatarURL} onError={onImageError} />
              </div>

              <div className="avatar-upload__btns">
                <button onClick={() => handleState("showCamera", true)}>Use Webcam</button>
                <button onClick={() => handleState("showUpload", true)}>Upload Image</button>
              </div>
            </>
          )}

          <AvatarUpload
            showCamera={state.showCamera}
            showUpload={state.showUpload}
            handleState={handleState}
            onImageError={onImageError}
            id={userParams.user.params.id}
            organization_id={userParams.user.params.organization_id}
          />
        </div>
      </div>
    </div>
  );
}
